<div class="w-full min-h-screen bg-white p-3 md:p-5">
  <p-toast></p-toast>

  <p-confirmDialog
    [breakpoints]="{'960px': '75vw', '640px': '90vw'}"
    [style]="{width: '50vw'}"
    acceptLabel="Sí"
    rejectLabel="Cancelar"
    rejectButtonStyleClass="p-button-danger">
  </p-confirmDialog>

  <div class="flex flex-column md:flex-row justify-content-between align-items-start md:align-items-center gap-3 mb-4">
    <div>
      <h2 class="m-0 text-900 text-2xl font-bold">Clientes</h2>
      <p class="m-0 mt-1 text-600 text-sm">Ficha única para ventas manuales y cuenta web.</p>
    </div>
    <div class="flex flex-wrap gap-2">
      <button pButton label="Invitar sin cuenta" icon="pi pi-send"
              class="p-button-outlined border-round-3xl text-900"
              [disabled]="inviting || kpis.sinCuentaWeb === 0"
              (click)="inviteAll()"></button>
      <button pButton label="Nuevo Cliente" icon="pi pi-plus"
              class="p-button-black border-round-3xl"
              (click)="openNew()"></button>
    </div>
  </div>

  <div class="grid mb-4">
    <div class="col-12 md:col-3">
      <div class="stat-card">
        <span class="stat-label">Total clientes</span>
        <span class="stat-value">{{ kpis.total }}</span>
      </div>
    </div>
    <div class="col-12 md:col-3">
      <div class="stat-card">
        <span class="stat-label">Sin correo</span>
        <span class="stat-value">{{ kpis.sinCorreo }}</span>
      </div>
    </div>
    <div class="col-12 md:col-3">
      <div class="stat-card">
        <span class="stat-label">Sin cuenta web</span>
        <span class="stat-value">{{ kpis.sinCuentaWeb }}</span>
      </div>
    </div>
    <div class="col-12 md:col-3">
      <div class="stat-card">
        <span class="stat-label">Invitaciones enviadas</span>
        <span class="stat-value">{{ kpis.invitacionesEnviadas }}</span>
      </div>
    </div>
  </div>

  <div class="flex flex-column md:flex-row justify-content-between align-items-center gap-3 mb-4">
    <span class="p-input-icon-left w-full md:w-auto">
      <input pInputText type="text" [(ngModel)]="search" (input)="scheduleServerLoad()"
             placeholder="Buscar por nombre, celular o correo..."
             class="w-full md:w-24rem border-round-3xl input-search" />
    </span>
  </div>

  <p-table #dt [value]="clientes" [lazy]="true" (onLazyLoad)="load($event)"
           [first]="first" [rows]="rows" [totalRecords]="totalRecords" [paginator]="true"
           [rowsPerPageOptions]="[10, 25, 50]"
           [loading]="loading"
           [tableStyle]="{ 'min-width': '60rem' }"
           [rowHover]="true"
           styleClass="p-datatable-sm">
    <ng-template pTemplate="header">
      <tr class="uppercase text-xs text-500">
        <th>Nombre</th>
        <th>Celular</th>
        <th>Correo</th>
        <th>Dirección</th>
        <th class="text-center">Cuenta web</th>
        <th class="text-center">Invitación</th>
        <th class="text-center">Estado</th>
        <th class="text-center">Acciones</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-item>
      <tr class="text-sm">
        <td class="font-bold text-900">
          {{ item.nombreCliente }}
          <div class="text-xs text-500 font-normal" *ngIf="item.dni">DNI: {{ item.dni }}</div>
        </td>
        <td class="text-600">{{ item.celular }}</td>
        <td class="text-600">{{ item.email || '—' }}</td>
        <td class="text-600 text-xs">
          <div>{{ direccionResumen(item) }}</div>
          <div class="text-500" *ngIf="item.direccion">{{ item.direccion }}</div>
        </td>
        <td class="text-center">
          <span [class]="'text-xs font-bold px-2 py-1 border-round ' + cuentaClass(item.cuentaEstado)">
            {{ cuentaLabel(item.cuentaEstado) }}
          </span>
          <div class="text-xs text-500 mt-1" *ngIf="item.username">@{{ item.username }}</div>
        </td>
        <td class="text-center text-xs text-600">
          <ng-container *ngIf="item.invitationSentAt; else sinInvitacion">
            {{ item.invitationSentAt | date:'dd/MM/yyyy HH:mm' }}
          </ng-container>
          <ng-template #sinInvitacion>—</ng-template>
        </td>
        <td class="text-center">
          <span [class]="'text-xs font-bold px-2 py-1 border-round ' + (item.isActive ? 'bg-green-100 text-green-700' : 'bg-red-100 text-red-700')">
            {{ item.isActive ? 'ACTIVO' : 'INACTIVO' }}
          </span>
        </td>
        <td class="text-center">
          <div class="flex justify-content-center gap-1">
            <button pButton icon="pi pi-envelope" class="p-button-text p-button-rounded text-600"
                    [disabled]="!canInvite(item) || inviting"
                    (click)="inviteOne(item)"
                    pTooltip="Invitar a registrarse"></button>
            <button pButton icon="pi pi-pencil" class="p-button-text p-button-rounded text-600 hover:text-900"
                    (click)="edit(item)" pTooltip="Editar"></button>
            <button pButton icon="pi pi-power-off" class="p-button-text p-button-rounded"
                    [ngClass]="item.isActive ? 'text-red-400 hover:text-red-600' : 'text-green-400 hover:text-green-600'"
                    (click)="toggle(item)" pTooltip="Activar/Desactivar"></button>
          </div>
        </td>
      </tr>
    </ng-template>
  </p-table>

  <p-dialog [(visible)]="dialog" header="Ficha de Cliente" [modal]="true"
            [breakpoints]="{'960px': '75vw', '640px': '95vw'}"
            [style]="{width: '560px'}" styleClass="p-fluid">
    <div class="flex flex-column gap-3 pt-2">
      <div class="field">
        <label class="font-bold">Nombre completo *</label>
        <input pInputText [(ngModel)]="cliente.nombreCliente" required autofocus />
        <small class="p-error" *ngIf="submitted && !cliente.nombreCliente?.trim()">Nombre requerido.</small>
      </div>
      <div class="field">
        <label class="font-bold">Celular / WhatsApp *</label>
        <input pInputText [(ngModel)]="cliente.celular" required />
        <small class="p-error" *ngIf="submitted && !cliente.celular?.trim()">Celular requerido.</small>
      </div>
      <div class="field">
        <label class="font-bold">Correo electrónico</label>
        <input pInputText type="email" [(ngModel)]="cliente.email" placeholder="Opcional — útil para boletas e invitaciones" />
        <small class="p-error" *ngIf="submitted && !isValidEmail(cliente.email)">Correo inválido.</small>
      </div>
      <div class="field">
        <label class="font-bold">DNI / CE</label>
        <input pInputText [(ngModel)]="cliente.dni" placeholder="Opcional" />
      </div>

      <div class="border-top-1 surface-border pt-3">
        <p class="m-0 mb-3 text-sm text-600 font-semibold">Dirección (opcional)</p>
        <div class="formgrid grid">
          <div class="field col-12 md:col-6">
            <label class="font-bold">País</label>
            <p-select [options]="paises" [(ngModel)]="paisId" (onChange)="onPaisChange()"
                      optionLabel="nombre" optionValue="id" placeholder="País"
                      [showClear]="true" styleClass="w-full" appendTo="body"></p-select>
          </div>
          <div class="field col-12 md:col-6">
            <label class="font-bold">Departamento</label>
            <p-select [options]="departamentos" [(ngModel)]="departamentoId" (onChange)="onDepartamentoChange()"
                      optionLabel="nombre" optionValue="id" placeholder="Departamento"
                      [showClear]="true" styleClass="w-full" appendTo="body"></p-select>
          </div>
          <div class="field col-12 md:col-6">
            <label class="font-bold">Provincia / Ciudad</label>
            <p-select [options]="provincias" [(ngModel)]="provinciaId" (onChange)="onProvinciaChange()"
                      optionLabel="nombre" optionValue="id" placeholder="Provincia"
                      [showClear]="true" styleClass="w-full" appendTo="body"></p-select>
          </div>
          <div class="field col-12 md:col-6">
            <label class="font-bold">Distrito</label>
            <p-select [options]="distritos" [(ngModel)]="cliente.distritoId"
                      optionLabel="nombre" optionValue="id" placeholder="Distrito"
                      [showClear]="true" styleClass="w-full" appendTo="body"></p-select>
          </div>
          <div class="field col-12">
            <label class="font-bold">Dirección exacta</label>
            <input pInputText [(ngModel)]="cliente.direccion" placeholder="Av. Principal 123..." />
          </div>
        </div>
      </div>
    </div>
    <ng-template pTemplate="footer">
      <button pButton label="Cancelar" icon="pi pi-times" class="p-button-text text-900" (click)="dialog = false"></button>
      <button pButton label="Guardar" icon="pi pi-check" class="p-button-black" (click)="save()"></button>
    </ng-template>
  </p-dialog>
</div>
